import { atom } from "recoil";

const destinationState =atom({
    key: 'destination',
    default: 'Address'
})

export default destinationState